import React from "react";
import { hashHistory } from "react-router";
import userStore from "../../../store/userStore";
import App_data from "../../config/App_data";
import FD from "../../RestAPI/fetchData";
import {connectSocket} from "../../../services/WebSocketService";

class SessionWatcher extends React.Component {
    intervalId = null;

    componentDidMount() {
        this.refreshNow();

        this.intervalId = setInterval(() => {
            this.refreshNow();
        }, 2 * 60 * 60 * 1000); // every 2 hours
        this.connectWSs();
    }

    connectWSs = () => {
        const ls = this.getStoredSession();
        if(ls && ls.token){
            connectSocket(ls.token);
        }

    }

    componentWillUnmount() {
        if (this.intervalId) clearInterval(this.intervalId);
    }

    redirectToLogin = () => {
        try { userStore.clear(); } catch (e) { }

        try { localStorage.removeItem("localstorageval"); } catch (e) { }

        try {
            hashHistory.push("/");
        } catch (e) {
            window.location.href = "/";
        }
    };
    getStoredSession = () => {
        try {
            const raw = localStorage.getItem("localstorageval");
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return null;
        }
    };

    setStoredToken = (newToken) => {
        try {
            const s = this.getStoredSession() || {};
            localStorage.setItem("localstorageval", JSON.stringify({ ...s, token: newToken }));
        } catch (e) { }
    };

    /**
     * Returns true if the error is a transient network/backend-outage error
     * (e.g. nodemon restart, DNS blip, offline). Logging out for these would
     * log the user out every time the dev server restarts — we should keep
     * the session and let the user retry.
     */
    isTransientError = (e) => {
        if (!e) return false;
        const message = String(e.message || e).toLowerCase();
        return (
            e.name === 'TypeError' || // `fetch` throws TypeError on network failure
            message.includes('failed to fetch') ||
            message.includes('networkerror') ||
            message.includes('network request failed') ||
            message.includes('load failed')
        );
    };

    refreshNow = async () => {
        const s = this.getStoredSession();
        const storedToken = s && s.token ? s.token : null;

        if (!storedToken && !userStore.token) return;

        if (!userStore.token && storedToken) {
            userStore.setToken(storedToken);
        }

        try {
            const resp = await FD.callAPI(`${App_data.backend_api}/user/refreshToken`, {});
            const { success, token } = resp || {};

            if (success && token) {
                userStore.setToken(token);
                this.setStoredToken(token);
                return;
            }

            // Explicit failure from server (e.g. invalid/expired token) → logout.
            // Keep user signed in if the server did not return a clear failure.
            if (resp && resp.success === false) {
                this.redirectToLogin();
            }
        } catch (e) {
            // Never log out on transient network errors (e.g. nodemon restart).
            if (this.isTransientError(e)) {
                console.warn('SessionWatcher: transient error during token refresh — keeping session', e.message);
                return;
            }
            this.redirectToLogin();
        }
    };

    render() {
        return this.props.children;
    }
}

export default SessionWatcher;



// WEBPACK FOOTER //
// ./src/views/Pages/Auth/SessionWatcher.js